import { createSlice } from "@reduxjs/toolkit";
import { getMyTickets, getTicketsByConfirmationID } from "../actions/ticketActions";

const initialState={
    upcoming:[],
    expired:[],
    all:[],
    lookup: [],
    total_upcoming:0,
    total_expired:0,
    total_all:0,
    total_lookup:0,
    pagination:{},
    lookup_pagination:{},
    failed_purchase_attempts: 0,
    // Enriched ticket rows the user just bought — populated from the
    // /payment/success response. My Tickets merges these into its list so a
    // guest (who cannot call the authenticated endpoint) still sees what they
    // just bought, and the purchased-ticket viewer reads them too.
    purchased_tickets: [],
    show_purchased_ticket: false,
    // Post-purchase confirmation dialog. Separate from the viewer above: this
    // one confirms the order, the viewer shows the QR. Both read
    // purchased_tickets, so a buyer can go from one to the other.
    show_purchase_success: false,
}

const ticketSlice=createSlice({
    name:'tickets',
    initialState:initialState,
    reducers:{
        upcoming:(state,action)=>{
            state.my_tickets=action.payload;
        },
        expired:(state,action)=>{
            state.my_tickets=action.payload;
        },
        failPurchaseAttempt:(state,action)=>{
            state.failed_purchase_attempts = state.failed_purchase_attempts + 1;
        },
        resetFailPurchaseAttempt:(state,action)=>{
            state.failed_purchase_attempts = 0;
        },
        resetLookup: (state, action) => {
            state.lookup = [],
            state.total_lookup = 0;
            state.lookup_pagination = {}
        },
        setPurchasedTickets: (state, action) => {
            state.purchased_tickets = action.payload || [];
        },
        showPurchasedTicket: (state, action) => {
            state.show_purchased_ticket = !!action.payload;
        },
        showPurchaseSuccess: (state, action) => {
            state.show_purchase_success = !!action.payload;
        }
    },
    extraReducers:(builder)=>{
        builder.addCase(getMyTickets.fulfilled,(state,action)=>{
            if(action.payload.type == 'upcoming'){
                if(action.payload.pagination.current_page == 1)
                    state.upcoming = action.payload.data;
                else
                    state.upcoming = [...state.upcoming, ...action.payload.data];

                state.total_upcoming = action.payload.pagination.total;
            }
            if(action.payload.type == 'expired'){
                if(action.payload.pagination.current_page == 1)
                    state.expired = action.payload.data;
                else
                    state.expired = [...state.expired, ...action.payload.data];

                state.total_expired = action.payload.pagination.total;
            }
            // No `type` ⇒ the combined "all tickets" list (past + future). The
            // My Tickets page fetches this for the single unified list.
            if(action.payload.type != 'upcoming' && action.payload.type != 'expired'){
                if(action.payload.pagination.current_page == 1)
                    state.all = action.payload.data;
                else
                    state.all = [...state.all, ...action.payload.data];

                state.total_all = action.payload.pagination.total;
            }
            state.pagination = action.payload.pagination
        }).addCase(getTicketsByConfirmationID.fulfilled,(state,action)=>{
            if(action.payload.pagination.current_page == 1)
                state.lookup = action.payload.data;
            else
                state.lookup = [...state.lookup, ...action.payload.data];

            state.total_lookup = action.payload.pagination.total;
            state.lookup_pagination = action.payload.pagination
        })
    }
});

export const {upcoming, expired, failPurchaseAttempt, resetFailPurchaseAttempt, resetLookup, setPurchasedTickets, showPurchasedTicket, showPurchaseSuccess} = ticketSlice.actions;
export default ticketSlice.reducer;
